import { toast } from 'react-toastify'
import { formatPriceCompact } from '@/utils/courseFormat'

export const KM_SHARE_TAG = 'M2MBA'

export type KmComboShareInput = {
  sourceCourseName: string
  giftCourseName: string
  giftCourseFee: number
  sourceCourseHashId?: string | null
  sourceCourseId: number
  /** User id for affiliate ref query param */
  refUserId?: number | null
}

export function buildKmComboShareUrl(input: KmComboShareInput): string {
  const path = `/courses/${input.sourceCourseHashId || input.sourceCourseId}`
  const url = new URL(path, window.location.origin)
  if (input.refUserId != null && input.refUserId > 0) {
    url.searchParams.set('ref', String(input.refUserId))
  }
  return url.toString()
}

export function buildKmComboShareMessage(input: KmComboShareInput): string {
  const url = buildKmComboShareUrl(input)
  const saveLabel = formatPriceCompact(input.giftCourseFee)
  return (
    `${KM_SHARE_TAG} - combo ưu đãi tiết kiệm ${saveLabel} đồng\n\n` +
    `Đăng ký "${input.sourceCourseName}" được tặng kèm "${input.giftCourseName}".\n\n` +
    `👉 ${url}`
  )
}

/**
 * Share tin nhắn KM (Web Share API) hoặc copy clipboard + toast.
 * Chỉ dùng `text` (đã gồm URL) — không truyền `url` riêng vì nhiều app
 * (Gmail, …) bỏ qua text và chỉ gửi link.
 */
export async function shareKmCombo(input: KmComboShareInput): Promise<'shared' | 'copied' | 'aborted'> {
  const text = buildKmComboShareMessage(input)
  const title = `${KM_SHARE_TAG} - combo ưu đãi`

  if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
    try {
      await navigator.share({ title, text })
      return 'shared'
    } catch (err) {
      if (err instanceof DOMException && err.name === 'AbortError') {
        return 'aborted'
      }
    }
  }

  try {
    await navigator.clipboard.writeText(text)
    toast.success('Đã copy tin nhắn giới thiệu')
    return 'copied'
  } catch {
    toast.error('Không copy được tin nhắn. Vui lòng thử lại.')
    throw new Error('clipboard_failed')
  }
}
